import axios from "axios";

const baseReq = axios.create({
  baseURL: '',
  timeout: 8000
});

baseReq.interceptors.response.use(res => {
  if (res.data.code === 200) {
    return res.data.data;
  } else {
    return Promise.reject(res.data.msg);
  }
});

/**
 * 生成短链接
 * @param {String} url 
 */
export const getShortUrl = (url) => {
  return baseReq.get('/kzplatform/api/v1/plugin/tk/domain/shortUrl', {
    params: {
      url
    }
  });
}
